export interface GetLandingPagesParams {
    page?: number;
    page_size?: number;
    search?: string;
}

export interface LandingPagesListState {
    isLoadingList: boolean | null;
    data: any;
    pagination: {
        total: number;
        per_page: number;
        current_page: number;
        last_page: number;
    };
}

export interface SimpleListState {
    isLoadingList: boolean | null;
    data: any;
}

export interface LoadingDataState {
    data: any;
    isLoading: boolean | null;
}

export interface LandingPagesState {
    landingPages: LandingPagesListState;
    templates: SimpleListState;
    gamificationTemplates: SimpleListState;
    customSources: SimpleListState;
    lastAddedLandingPage: any;
    lastAddedDraftLandingPage: any;
    landingPageForm: Record<string, any>;
    isLandingPageFormLoading: boolean;
    isLandingPageCreated: boolean;
    isCloneLandingPageLoading: boolean;
    deletingLandingPageId: number | null;
    landingPageDetails: any;
    appDetails: LoadingDataState;
    mmpDetails: LoadingDataState;
    code: LoadingDataState;
}

export const initialState: LandingPagesState = {
    landingPages: {
        isLoadingList: null,
        data: null,
        pagination: {
            total: 0,
            per_page: 20,
            current_page: 1,
            last_page: 1,
        },
    },
    templates: {
        isLoadingList: null,
        data: null,
    },
    gamificationTemplates: {
        isLoadingList: null,
        data: null,
    },

    customSources: {
        isLoadingList: null,
        data: null,
    },

    lastAddedLandingPage: null,
    lastAddedDraftLandingPage: null,
    landingPageForm: {},
    isLandingPageFormLoading: false,
    isLandingPageCreated: false,
    isCloneLandingPageLoading: false,
    deletingLandingPageId: null,

    landingPageDetails: null,

    appDetails: {
        data: null,
        isLoading: null,
    },
    mmpDetails: {
        data: null,
        isLoading: null,
    },

    code: {
        data: null,
        isLoading: null,
    },
};
